<template>
     <!-- 编辑单位用户 -->
     <el-dialog title="账户" width="25%" :visible.sync="dialogVisible" :show-close="false" :close-on-click-modal="false" destroy-on-close>
        
          
          <el-upload drag :multiple="false" ref="fileRef" action="#" accept=".xlsx,.xls" :auto-upload="false" :limit="1" @before-upload="handleChange">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传xlsx/xls文件，且不超过10Mb</div>
          </el-upload>

  
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="closeDialog">取 消</el-button>
          <el-button size="small" @click="handleChange()" type="primary" :loading="loading">确 定</el-button>
        </div>
      </el-dialog>  
</template>

<script>
import { getInfo,storeAccountInfo } from "@/cookie";
import { Message,MessageBox } from 'element-ui';
import { editorAccount } from "@/api/account";
import * as XLSX from 'xlsx';

export default {
  name: "ReadExcelDialog",
  props: {
    dialogVisible: false
  },
  data(){
    return {
      rules: {},
      loading:false,
      accountInfo : {
        id: '',
        email : '-',
        openId: '',
        phone:'',
        unitName:'',
        unitTaxCode:'',
        userName:''
      },
    }
  },
  mounted(){
     let info_ = getInfo();
     this.accountInfo = {...info_};
     this.accountInfo.id = info_.uid;
  },
  created() {

  },
  watch : {
    
  },
  methods: {
    
    //打开新增用户弹窗
    closeDialog(){
      this.$emit('close');
    },


    handleChange(data){
      let file = this.$refs.fileRef.uploadFiles[0];
      console.log(file);
      this.parseExcel(file);
    },

    parseExcel(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array'});
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);
        console.log(jsonData);
      };
      reader.readAsArrayBuffer(file.raw);
    },
    
  },
};
</script>

<style>
.znk_form_item {
  margin-bottom: 5px !important;
}
.el-upload-dragger {
  width: 100% !important;
}
.el-upload {
  width: 100% !important;
}
</style>


// WEBPACK FOOTER //
// src/views/components/dialog/ReadExcelDialog.vue